import { render, staticRenderFns } from "./GlobalSearchInput.vue?vue&type=template&id=6abcc4be"
import script from "./GlobalSearchInput.vue?vue&type=script&lang=js"
export * from "./GlobalSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports